import { AfterViewInit, Component, Input, OnInit, Optional, Self, ViewChild } from '@angular/core';
import { ControlValueAccessor, FormControl, NgControl } from '@angular/forms';
import { NgOtpInputComponent, NgOtpInputConfig } from 'ng-otp-input';
import { SharedModule } from '@app/shared/shared.module';
@Component({
    selector: 'c-otp-input',
    templateUrl: './otp.component.html',
  styleUrl: './otp.component.scss',
  imports: [SharedModule],
})
export class OtpInputComponent<T = any> implements OnInit, AfterViewInit, ControlValueAccessor {
  @Input() label: string;
  @Input() length = 6;
  @Input() allowNumbersOnly: boolean;
  // Optional per-usage override of the box styling. Falls back to the shared
  // register/phone-verification look when not provided.
  @Input() inputStyles?: Record<string, string>;

  /**
   * Makes the boxes read-only while leaving the bound control enabled, so it
   * keeps its validity. Disabling the control itself would turn it DISABLED.
   */
  @Input() set locked(locked: boolean) {
    this._locked = locked;
    this.otpInput?.setDisabledState(locked);
  }

  @ViewChild(NgOtpInputComponent) private otpInput?: NgOtpInputComponent;

  private _locked = false;

  private readonly defaultInputStyles: Record<string, string> = {
    'background-color': 'var(--c-wizard-lightest)',
    'border': 'none',
    'width': '50px',
    'height': '40px',
    'border-radius': '6px',
    'font-size': '18px',
    'padding': '3px',
    flex: '1',
  };

  config: NgOtpInputConfig;

  get control() {
    return this.ngControl?.control as FormControl;
  }

  constructor(@Optional() @Self() public ngControl: NgControl) {
    if (this.ngControl) {
      this.ngControl.valueAccessor = this;
    }
  }

  ngOnInit(): void {
    this.config = {
      length: this.length,
      allowNumbersOnly: this.allowNumbersOnly,
      inputStyles: this.inputStyles ?? this.defaultInputStyles,
    };
  }

  ngAfterViewInit(): void {
    if (this._locked) {
      this.otpInput?.setDisabledState(true);
    }
  }

  writeValue(value: any): void {}

  onChange = (value: T) => {};
  onTouched = () => {};

  registerOnChange(fn: (value: T) => void): void {
    this.onChange = fn;
  }

  // eslint-disable-next-line @typescript-eslint/ban-types
  registerOnTouched(fn: () => {}): void {
    this.onTouched = fn;
  }
}
